import { Reveal } from "@/components/Reveal";
import { Music, GlassWater, PartyPopper, Sparkles } from "lucide-react";

const CEREMONY_IMG = "https://images.unsplash.com/photo-1700660427943-8331e935313d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjB3ZWRkaW5nJTIwc3RyaW5nJTIwcXVhcnRldHxlbnwwfHx8fDE3OTE5MTM4MzZ8MA&ixlib=rb-4.1.0&q=85";
const RECEPTION_IMG = "https://images.unsplash.com/photo-1759519238029-689e99c6d19e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjB3ZWRkaW5nJTIwcmVjZXB0aW9uJTIwYmFsbHJvb218ZW58MHx8fHwxNzkxOTEzODM2fDA&ixlib=rb-4.1.0&q=85";

const CARDS = [
    {
        icon: Music, title: "Ceremony & Processional",
        text: "Beautiful processional music and a string quartet for your walk down the aisle — arranged to your taste.",
        img: CEREMONY_IMG, alt: "String musician at a wedding ceremony", testId: "service-ceremony-card",
    },
    {
        icon: GlassWater, title: "Cocktail Hour",
        text: "Jazz, classical crossover and international classics that set the tone as your guests arrive.",
        testId: "service-cocktail-card",
    },
    {
        icon: PartyPopper, title: "Reception & Dancing",
        text: "A full orchestra with vocalists — power ballads to Top 40 — that keeps your guests dancing all night long.",
        img: RECEPTION_IMG, alt: "Grand wedding reception ballroom", testId: "service-reception-card",
    },
    {
        icon: Sparkles, title: "Custom Packages",
        text: "From the initial consultation to the day of your event, every package is tailored to your vision and budget.",
        testId: "service-custom-card",
    },
];

export const Services = () => (
    <section id="weddings" data-testid="services-section" className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <Reveal>
                <p className="text-xs uppercase tracking-[0.35em] text-[#d4af37] mb-4">Weddings &amp; Events</p>
                <h2 className="font-serif text-4xl sm:text-5xl tracking-tight font-light text-[#fafafa] max-w-2xl">
                    The time of your life, <em className="text-[#d4af37]">scored live.</em>
                </h2>
            </Reveal>
            <div className="mt-16 grid md:grid-cols-2 gap-6">
                {CARDS.map((c, i) => (
                    <Reveal key={c.testId} delay={(i % 2) * 0.12}>
                        <article data-testid={c.testId}
                            className="group relative overflow-hidden border border-white/10 bg-[#121216] hover:-translate-y-1 transition-transform duration-500 h-full">
                            {c.img && (
                                <div className="relative h-56 overflow-hidden">
                                    <img src={c.img} alt={c.alt} className="w-full h-full object-cover img-luxe" loading="lazy" />
                                    <div className="absolute inset-0 bg-gradient-to-t from-[#121216] to-transparent" />
                                </div>
                            )}
                            <div className="p-8">
                                <c.icon size={20} className="text-[#d4af37]" />
                                <h3 className="mt-4 font-serif text-2xl sm:text-3xl font-light text-[#fafafa]">{c.title}</h3>
                                <p className="mt-3 text-sm sm:text-base text-[#a1a1aa] leading-relaxed">{c.text}</p>
                            </div>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
